import moment from "moment";

export const endDate = moment().subtract(1,'month').endOf('months').format('YYYY-MM-DD');
export const startDate = moment().add(1,'months').startOf('months').format('YYYY-MM-DD');